import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, IconButton, Typography } from '@material-ui/core'
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined'
import { useStyles } from "./ModalStyles"
import clsx from 'clsx'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const ModalCommon = ({ ...props }) => {
    const classes = useStyles()
    const status = props.status

    return (
        <Dialog onClose={props.clickOpen} open={props.open} fullWidth maxWidth={props.maxWidth} disableBackdropClick={true} style={{maxHeight:"100%", overflowY:"scroll"}}> 
            <DialogTitle
                className={clsx(classes.button, {
                    [classes.default]: status === 'default',
                    [classes.warning]: status === 'warning',
                    [classes.success]: status === 'success',
                    [classes.error]: status === 'error',
                })}>
                <Grid container
                    justifyContent="space-between"
                    alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.White} variant={props.variant?props.variant:'h6'}>
                            {props.title}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogTitle >
            <DialogContent >
                {props.children}
            </DialogContent>
            <DialogActions>
                {props.submitButtonOff ? '' :
                    <IconButton aria-label="accept" disabled={props.disableSubmit} className={classes.margin} title={props.submitButtonTitle} onClick={props.clickSubmit}>
                        <CheckOutlinedIcon style={{color: props.disableSubmit ? "#808080" : "green", fontSize: props.fontSize? props.fontSize:"3rem"}} />
                    </IconButton>
                }
                {props.closeButtonOff ? '' :
                <IconButton aria-label="delete" className={classes.margin} title={props.closeButtonTitle} onClick={props.clickOpen}>
                    <CloseOutlinedIcon style={{color: "red", fontSize: props.fontSize? props.fontSize:"3rem"}} />
                </IconButton>
                }
            </DialogActions>
        </Dialog >
    );
}

export default ModalCommon